.marker {
  position: absolute;
  width: 2px;
  background-color: var(--tuna-palette-primary-light);
  opacity: 0.3;
  z-index: 1;
  height: 100%;
}
